// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "nav[data-v-6a506cf2]{display:flex;align-items:center}.breadcrumbs[data-v-6a506cf2]{list-style:none;padding-inline-start:0;margin:0 0 24px}.breadcrumbs__item[data-v-6a506cf2]{text-transform:capitalize}.breadcrumbs__delimiter[data-v-6a506cf2]{height:4px;width:1px;background-color:#657182;margin:0 12px}.breadcrumbs li[data-v-6a506cf2]{display:inline-flex;align-items:center}.breadcrumbs li a[data-v-6a506cf2],.breadcrumbs li span[data-v-6a506cf2]{color:#657182}", ""]);
// Exports
module.exports = exports;
